<template>
    <pm-app-component hide-sidebar barColor="#f3bb01" :hide-footer="hideFooter">

        <template v-if="$packageName === 'com.denticalc.4in1'" slot="mobile-toolbar">
            <pm-application-bar>
                {{ $t('menu.videos') }}
            </pm-application-bar>
            <mdi class="white--text" @click.native="toggleGrid" :key="grid">
                <template v-if="grid===4">checkerboard</template>
                <template v-else-if="grid===3">grid</template>
                <template v-else-if="grid===2">grid-large</template>
                <template v-else>view-agenda-outline</template>
            </mdi>
        </template>
        <template v-else slot="mobile-toolbar">
            <div style="flex-grow: 1; position: relative;">
                {{ $t('menu.videos') }}
            </div>
        </template>

        <div id="main-container" class="app-content-container" style="padding: 0!important; box-shadow: inset 0 8px 15px rgba(0,0,0,.03);" :class="['pm-animations-grid-'+grid]">
            <div style="position: absolute; top: 0px; bottom: 0px; left: 0; right: 0; padding: 0; box-shadow: 0 -8px 15px rgba(0,0,0,.03), 0 8px 15px rgba(0,0,0,.03); display: flex; flex-direction: column;"
                 :class="$theme.contentBg"
            >
                <slot name="default"></slot>
            </div>
        </div>

        <!-- <pm-welcome-screen v-if="onboarding.length > 0" :steps="onboarding" /> -->
    </pm-app-component>
</template>

<style>

</style>

<script>
import { onboarding } from "./onboarding.js"

const defaultGrid = 2;

export default {
    data: () => ({
        grid: defaultGrid,
        firstRun: false,
    }),

    props: {
        currentView: {
            type: String,
            default: "all",
        }
    },

    created() {
        this.setGrid();
        this.onboarding = onboarding();
    },

    methods: {
        toggleGrid() {
            this.grid--;
            if (this.grid === 0) this.grid = 3;
            localStorage.setItem('videoGrid', this.grid);
            this.$bus.$emit('videoGridToggled');
        },
        setGrid() {
            try {
                if (localStorage.getItem('videoGrid')) this.grid = parseInt(localStorage.getItem('videoGrid'));
                else localStorage.setItem('videoGrid', this.grid);
            } catch(error) {
                captureException(error);
            }
        },
    },
}
</script>
